import { CREATE_ARTICLES_MUTATION, kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { CREATE_ARTICLE_FROM_CANDIDATE } from './addArticleFromCandidate.mutation';
import { CREATE_PAGE_ARTICLES_MUTATION } from './createPageArticles.mutation';
import { AddArticleFromFeed, AddArticleFromFeedVariables } from './__generated__/AddArticleFromFeed';
import { CreateArticles, CreateArticlesVariables } from './__generated__/CreateArticles';
import { CreatePageArticles, CreatePageArticlesVariables } from './__generated__/CreatePageArticles';

export const useAddArticleFromCandidate = () => {
  return useMutation<AddArticleFromFeed, AddArticleFromFeedVariables>(CREATE_ARTICLE_FROM_CANDIDATE, {
    client: kmsClient
  });
};

export const useCreateArticlesFromUrls = () => {
  return useMutation<CreateArticles, CreateArticlesVariables>(CREATE_ARTICLES_MUTATION, {
    client: kmsClient
  });
};

export const useCreatePageArticlesFromUrls = () => {
  return useMutation<CreatePageArticles, CreatePageArticlesVariables>(CREATE_PAGE_ARTICLES_MUTATION, {
    client: kmsClient
  });
};
